import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import GameInterface from './index';
import store from '../../state/store';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';
import utils from '../../utils';
import { PLATFORM } from '../../constants';

var NetEnt = /*#__PURE__*/function (_GameInterface) {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function NetEnt(args) {
    var _this2;

    _classCallCheck(this, NetEnt);

    _this2 = _callSuper2(this, NetEnt, [args]);

    _this2.jsonParserEvent = function (payload) {
      var soundEffects = store.getState().playerInfo.soundEffects;

      if (soundEffects !== _this2.currentSoundSetting) {
        _this2.setSound();
      }

      switch (payload.event || payload.eventName) {
        case 'gameReady':
          _this2.setSound();

          _this2._gameReady();

          _this2.sendAnalyticEvent();

          break;

        case 'gameRoundEnded':
          _this2.getEvent('betInCents');

          _this2.getEvent('winInCents');

          _this2.getEvent('balanceInCents');

          break;

        case 'gameError':
          if (payload['100'] || payload['15'] || payload['10'] || payload.params === 100 || payload.params === 15 || payload.params === 10) {
            _this2._outOfCoins();

            _this2.showOutOfCoinsScreen();
          }

          break;

        case 'gameProp':
          _this2.checkEventData(payload.value, payload.item);

          break;

        default:
          {
            console.log('Unhandled event.', payload);
            break;
          }
      }
    };

    _this2.checkEventData = function (incomingData, eventName) {
      var _store$getState$lastS = store.getState().lastSpinEvents.balanceAfter,
          balance = _store$getState$lastS === void 0 ? null : _store$getState$lastS;
      var playerId = store.getState().playerInfo.playerId;
      var gameId = store.getState().gameInfo.gameId;

      switch (eventName) {
        case 'betInCents':
          _this2._currentBet = parseInt(incomingData) / 100;

          _this2.AddSpinXP(_this2._currentBet);

          store.dispatch(setSpinEvent({
            amount: _this2._currentBet,
            playerId: playerId,
            createdTimestamp: Date.now(),
            spinPhase: SPIN_PHASE.WAGE,
            gameId: gameId
          }));
          break;

        case 'winInCents':
          var win = parseInt(incomingData) / 100;
          if (win !== 0 && win >= 10 * _this2._currentBet && utils.getPlatform() !== PLATFORM.WEB) _this2.showRateUsScreen();

          if (win > 0) {
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WIN,
              gameId: gameId,
              amount: win
            }));

            _this2.SetLastWin(win);
          }

          break;

        case 'balanceInCents':
          var currentBalance = parseInt(incomingData) / 100;
          store.dispatch(setSpinEvent({
            balanceBefore: balance ? balance : currentBalance,
            balanceAfter: currentBalance
          }));

          _this2.syncCoinsBalance(currentBalance);

          if (currentBalance < _this2._currentBet) {
            _this2._outOfCoins();

            _this2.showOutOfCoinsScreen();
          }

          break;

        default:
          break;
      }
    };

    _this2.getEvent = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(eventName) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.sendEvent({
                  eventType: 'GET',
                  event: eventName
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this2._currentRound = 0;
    _this2._lastWinRound = 0;
    _this2._currentBet = 0;
    _this2.currentSoundSetting = false;
    return _this2;
  }
  /**
   * NetEnt Event Handler
   * @param {import("./helpers/parseEvent").ParsedEvent} event
   */


  _inherits(NetEnt, _GameInterface);

  return _createClass(NetEnt, [{
    key: "setSound",
    value: function setSound() {
      var soundEffects = store.getState().playerInfo.soundEffects;
      this.sendEvent({
        eventType: 'SET',
        event: 'audio',
        value: soundEffects
      });
      this.currentSoundSetting = soundEffects;
    }
  }]);
}(GameInterface);

export default NetEnt;